// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CveRetestJobStatusSchema = z.enum(['PENDING','RUNNING','COMPLETED','FAILED'] as const);

export type CveRetestJobStatusType = `${z.infer<typeof CveRetestJobStatusSchema>}`

export default CveRetestJobStatusSchema;
